const DoubleArrow = () => {

    return <i className="fa fa-angle-double-up" />
}

export default DoubleArrow;
